'use client';

import {
    Badge,
    Button,
    Card,
    CardContent,
    CardHeader,
    CardTitle,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from '@repo/shadcn';
import { CalendarDays } from 'lucide-react';
import { useState } from 'react';
import { TbReport } from 'react-icons/tb';
import { Link } from 'react-router-dom';

import { CustomSkelton } from '@/components/ui/custom.skelton';
import { Route } from '@/constants';
import { useGetAllOrdersQuery } from '@/features/slice/order';
import { formatCurrencyInBDT } from '@/utils/currency-formater';
import { formatDate } from '@/utils/date-formater';

export default function TransactionsTable() {
    const [searchQuery] = useState('');
    const { data, isLoading } = useGetAllOrdersQuery({
        limit: 10,
        page: 1,
        search: searchQuery,
    });

    const statusColors = {
        paid: 'bg-green-500/15 text-green-700 capitalize',
        due: 'bg-yellow-500/15 text-yellow-700 capitalize',
    };

    return (
        <Card>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-7">
                <div className="space-y-1.5">
                    <CardTitle className="text-2xl font-bold">
                        Recent Sales
                    </CardTitle>
                    <p className="text-sm text-muted-foreground">
                        You made 265 sales this month.
                    </p>
                </div>
                <div className="flex items-center gap-2">
                    <Link to={Route.SALES}>
                        <Button variant="outline" size="sm">
                            <TbReport className="mr-2 h-4 w-4" />
                            See All
                        </Button>
                    </Link>
                </div>
            </CardHeader>
            <CardContent>
                {isLoading ? (
                    <CustomSkelton count={8} type="table" />
                ) : (
                    <div className="rounded-md border">
                        <Table>
                            <TableHeader>
                                <TableRow>
                                    <TableHead>Invoice</TableHead>
                                    <TableHead>Customer</TableHead>
                                    <TableHead>Date</TableHead>
                                    <TableHead>Status</TableHead>
                                    <TableHead>Items</TableHead>
                                    <TableHead className="text-right">
                                        Amount
                                    </TableHead>
                                    <TableHead className="w-[50px]"></TableHead>
                                </TableRow>
                            </TableHeader>
                            <TableBody>
                                {data?.data?.map((transaction) => (
                                    <TableRow key={transaction.id}>
                                        <TableCell className="font-medium">
                                            {transaction.invoice_number}
                                        </TableCell>
                                        <TableCell>
                                            {transaction.customer?.name ??
                                                'Unknown'}
                                        </TableCell>
                                        <TableCell>
                                            {transaction.customer_type}
                                        </TableCell>
                                        <TableCell className="text-muted-foreground">
                                            <div className="flex items-center gap-1">
                                                <CalendarDays className="h-3.5 w-3.5" />
                                                {formatDate(
                                                    transaction.created_at,
                                                )}
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <Badge
                                                variant="secondary"
                                                className={
                                                    statusColors[
                                                        transaction.status
                                                    ]
                                                }
                                            >
                                                {transaction.status}
                                            </Badge>
                                        </TableCell>

                                        <TableCell className="text-right">
                                            {formatCurrencyInBDT(
                                                transaction.payment
                                                    ?.total_price ?? 0,
                                            )}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </div>
                )}
            </CardContent>
        </Card>
    );
}
